/**
 * Main entry point for Shell Frontend
 *
 * Shell Design System v5.0
 * - BrowserRouter for client-side routing
 * - StrictMode for development warnings
 */

import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import App from './App.jsx'
import './index.css'

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>,
)
